export default __webpack_public_path__ + "static/media/wat.44d4fafc.svg";